<p-dialog
    [(visible)]="visible"
    (visibleChange)="visibleChange.emit($event)"
    [modal]="true"
    [dismissableMask]="true"
    [style]="{ width: '573px' }"
    [header]="'user.account.subscriptionTab.invoices.detailTitle' | transloco">

    <div *ngIf="loading" style="display:flex; justify-content:center; padding: 24px 0;">
        <p-progressSpinner styleClass="small-spinner"></p-progressSpinner>
    </div>

    <div *ngIf="!loading && loadError" style="text-align:center; padding: 16px 0;">
        <p>{{ 'user.account.subscriptionTab.invoices.detailLoadError' | transloco }}</p>
        <button pButton type="button"
                [label]="'user.account.subscriptionTab.invoices.retry' | transloco"
                (click)="invoiceId && loadDetail(invoiceId)"></button>
    </div>

    <div *ngIf="!loading && !loadError && invoice">
        <div class="invoice-detail-row">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.colPlan' | transloco }}</span>
            <span>{{ displayName(invoice) }}</span>
        </div>
        <div class="invoice-detail-row">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.colType' | transloco }}</span>
            <p-tag [value]="typeLabel(invoice)" severity="secondary"></p-tag>
        </div>
        <div class="invoice-detail-row">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.colDate' | transloco }}</span>
            <span>{{ invoice.paidAt | date:'dd/MM/yyyy' }}</span>
        </div>
        <div class="invoice-detail-row">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.colAmount' | transloco }}</span>
            <span>{{ invoice.amount | currency: invoice.currency }}</span>
        </div>
        <div class="invoice-detail-row">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.colNfStatus' | transloco }}</span>
            <p-tag [value]="nfStatusLabel(invoice.nfStatus)" [severity]="nfStatusSeverity(invoice.nfStatus)"></p-tag>
        </div>

        <hr class="invoice-detail-divider" />

        <h4>{{ 'user.account.subscriptionTab.invoices.billingTitle' | transloco }}</h4>
        <div class="invoice-detail-row" *ngIf="invoice.billing.name">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.billingName' | transloco }}</span>
            <span>{{ invoice.billing.name }}</span>
        </div>
        <div class="invoice-detail-row" *ngIf="invoice.billing.email">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.billingEmail' | transloco }}</span>
            <span>{{ invoice.billing.email }}</span>
        </div>
        <div class="invoice-detail-row" *ngIf="invoice.billing.phone">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.billingPhone' | transloco }}</span>
            <span>{{ invoice.billing.phone }}</span>
        </div>
        <div class="invoice-detail-row" *ngIf="invoice.billing.document">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.billingDocument' | transloco }}</span>
            <span>{{ documentLabel() }}</span>
        </div>
        <div class="invoice-detail-row" *ngIf="formattedAddress()">
            <span class="invoice-detail-label">{{ 'user.account.subscriptionTab.invoices.billingAddress' | transloco }}</span>
            <span>{{ formattedAddress() }}</span>
        </div>

        <div class="invoice-detail-actions">
            <button pButton type="button" icon="pi pi-receipt"
                    [label]="'user.account.subscriptionTab.invoices.openReceipt' | transloco"
                    [disabled]="!invoice.stripeReceiptUrl"
                    [pTooltip]="!invoice.stripeReceiptUrl ? ('user.account.subscriptionTab.invoices.receiptNotAvailableTooltip' | transloco) : ''"
                    (click)="openReceipt()"></button>
            <button *ngIf="invoice.nfStatus === 'issued'" pButton type="button" icon="pi pi-file"
                    [label]="'user.account.subscriptionTab.invoices.viewNf' | transloco"
                    (click)="viewNf()"></button>
            <button *ngIf="invoice.nfStatus === 'issued'" pButton type="button" icon="pi pi-download"
                    [label]="'user.account.subscriptionTab.invoices.downloadNfXml' | transloco"
                    [loading]="downloadingNf"
                    (click)="downloadNfXml()"></button>
        </div>
        <p class="invoice-detail-nf-hint" *ngIf="invoice.nfStatus === 'pending' || invoice.nfStatus === 'requested'">
            {{ 'user.account.subscriptionTab.invoices.nfInProgress' | transloco }}
        </p>
        <p class="invoice-detail-nf-hint" *ngIf="invoice.nfStatus === 'failed'">
            {{ 'user.account.subscriptionTab.invoices.nfFailed' | transloco }}
        </p>
    </div>
</p-dialog>
